import React from "react";
import CarouselCardForm from "./CarouselCardForm";
import StandaloneCardForm from "./StandaloneCardForm";
import TextForm from "../components/TextForm";

const TemplateForm = ({ templateType, formData, setFormData, setCroppedFile,
    setRecommendedResolution, setAspectRatio, aspectRatio, recommendedResolution, route }) => {
    if (templateType === "text") {
        return <TextForm formData={formData} setFormData={setFormData} />;
    }
    if (templateType === "richcardcarousel") {
        return <CarouselCardForm formData={formData}
            setFormData={setFormData}
            setCroppedFile={setCroppedFile}
            setAspectRatio={setAspectRatio}
            setRecommendedResolution={setRecommendedResolution}
            aspectRatio={aspectRatio}
            recommendedResolution={recommendedResolution}
            route={route}
        />;
    }
    if (templateType === "richcardstandalone") {
        return <StandaloneCardForm
            formData={formData} setFormData={setFormData}
            setCroppedFile={setCroppedFile}
            setAspectRatio={setAspectRatio}
            setRecommendedResolution={setRecommendedResolution}
            aspectRatio={aspectRatio}
            recommendedResolution={recommendedResolution}
            route={route}
        />;
    }
    return null;
};

export default TemplateForm;
